// extracted by mini-css-extract-plugin
export default {"chipsPanel":"styles_chipsPanel__lQEGr","divider":"styles_divider__ljQLu","chipLabel":"styles_chipLabel__29dzI"};